import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import React, { useEffect, useState } from "react";
import { getStoreLocalData, getUserData } from "../../utils/localStorage";
import { Checkbox } from "primereact/checkbox";
import { orderInfoEdit, orderInfoEditAdmin } from "../../services/OrderEdit/orderInfoEdit";

const OrderInfoEditAdmin = ({
  orderInfoEditVisible,
  setOrderInfoEditVisible,
  customerOrdersData,
  storeId,
  storeUserId,
  storeCustomerId,
  processTime,
  sendResponse,
  storeGstNumber,
  storeCustomerData,
  profileCreatedDate
}) => {

  const { userProfileRole } = getUserData();
  const [otherRemarkValue, setOtherRemarkValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [isCheckedUrgentDelivery, setIsCheckedUrgentDelivery] = useState(false);
  const [isCheckedHomeDelivery, setCheckedHomeDelivery] = useState(false);
  const [regenerateInvoice, setRegenerateInvoice] = useState(true);
  const [regenerateQRCode, setRegenerateQRCode] = useState(false);
  const [isCheckedGST, setCheckedGST] = useState(false);
  const [userCheckGST, setUserCheckGST] = useState(false);
  const [gstAmountValue, setGstAmountValue] = useState("");

  const { storeLocalData } = getStoreLocalData();

  const [show, setShow] = useState(false);
    const handleShowHide = () => {
      setShow(!show);
    };

  useEffect(() => {
    if (customerOrdersData !== null) {
      // setFirstNameValue(selectedUserItemValue?.firstName || '');
      setBookingDate(new Date(customerOrdersData?.createdDate));
      setDeliveryDate(new Date(customerOrdersData?.deliveryOn));
      setDeliveredOnDate(new Date(customerOrdersData?.deliveredOn));
      setOtherRemarkValue(customerOrdersData?.remarks || "");
      setIsCheckedUrgentDelivery(customerOrdersData?.urgentDelivery);
      // setRegenerateInvoice(customerOrdersData?.regenerateInvoice);
      setCheckedHomeDelivery(customerOrdersData?.deliveryRequest);
      setGstAmountValue(customerOrdersData?.gstAmount);
      if (customerOrdersData?.gstAmount > 0) {
        setCheckedGST(true);
      }
      if (customerOrdersData.status === "INPROCESS") {
        setRegenerateQRCode(false);
      }
    }
  }, [customerOrdersData]);

  const handleGSTCheck = (isCheckedGST) => {
    setCheckedGST(!isCheckedGST);
    setUserCheckGST(true);
  };

  const handleOtherRemarkChange = (text) => {
    setOtherRemarkValue(text);
  };

  const [bookingDate, setBookingDate] = useState(new Date());

  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [deliveredOnDate, setDeliveredOnDate] = useState(new Date());

  const [showBookingDatePicker, setShowBookingDatePicker] = useState(false);
  const [showDeliveryDatePicker, setShowDeliveryDatePicker] = useState(false);
  const [showDeliveredOnDatePicker, setShowDeliveredOnDatePicker] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth());
  const minimumBookingDate = new Date();
  minimumBookingDate.setDate(minimumBookingDate.getDate() - 1);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);
  const maximumBookingDate = new Date();
  maximumBookingDate.setDate(maximumBookingDate.getDate() + 1);

  const maximumValidDate = maximumDate;
  const maximumValidDeliveredOnDate = new Date(customerOrdersData?.deliveredOn);

  const handleBookingDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];
      let deliveryDateOnly = deliveryDate.toISOString().split("T")[0];
      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly > deliveryDateOnly) {
        setErrorMessage("Booking Date cannot be greater than Delivery Date");
      } else {
        setErrorMessage("");
        // const utcDate = new Date(
        //   Date.UTC(
        //     selectedDate.getFullYear(),
        //     selectedDate.getMonth(),
        //     selectedDate.getDate()
        //   )
        // );
        setBookingDate(selectedDate);
      }
      setShowBookingDatePicker(false);
    }
  };

  const handleDeliveryDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];
      let bookingDateOnly = bookingDate.toISOString().split("T")[0];

      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly < bookingDateOnly) {
        setErrorMessage("Delivery Date cannot be less than Booking Date");
      } else {
        setErrorMessage("");
        // const utcDate = new Date(
        //   Date.UTC(
        //     selectedDate.getFullYear(),
        //     selectedDate.getMonth(),
        //     selectedDate.getDate()
        //   )
        // );

        setDeliveryDate(selectedDate);
      }
      setShowDeliveryDatePicker(false);
    }
  };

  const handleDeliveredOnDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];
      let bookingDateOnly = bookingDate.toISOString().split("T")[0];

      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly < bookingDateOnly) {
        setErrorMessage("Delivery Date cannot be less than Booking Date");
      } else {
        setErrorMessage("");
        // const utcDate = new Date(
        //   Date.UTC(
        //     selectedDate.getFullYear(),
        //     selectedDate.getMonth(),
        //     selectedDate.getDate()
        //   )
        // );
        setDeliveredOnDate(selectedDate);
      }
      setShowDeliveredOnDatePicker(false);
    }
  };

  const handleModalClose = () => {
    setOrderInfoEditVisible(false);
    setRegenerateInvoice(true);
    setRegenerateQRCode(true);
    setUserCheckGST(false);
    // setCheckedGST(false);
  };

  // const convertToUTC = (date) => {
  //   if (!date || !(date instanceof Date)) {
  //     console.error("Invalid date:", date);
  //     return null;
  //   }
  //   const offset = date.getTimezoneOffset(); // Offset in minutes
  //   return new Date(date.getTime() - (offset * 60 * 1000) + 1000).toISOString();
  // };

  // // Convert dates
  // const currentDateTimeBookingDate = convertToUTC(bookingDate);

  const onUpdateButtonPress = () => {
    // Reset all previous errors

    if (!errorMessage) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        const currentDateTimeBookingDate = new Date(bookingDate).toISOString();
        const currentDateTimeDeliveryDate = new Date(
          deliveryDate
        ).toISOString();
        const currentDateTimeDeliveredOnDate = new Date(
          deliveredOnDate
        ).toISOString();

        // const newDate = new Date(bookingDate);
        // newDate.setSeconds(newDate.getSeconds() + 1);
        // newDate.setHours(newDate.getHours(), newDate.getMinutes(), newDate.getSeconds(), newDate.getMilliseconds());

        // const updatedISOString = newDate.toISOString();

        const data = {
          id: customerOrdersData?.id,
          storeUserId: storeUserId,
          createdDate: currentDateTimeBookingDate,
          deliveryOn: currentDateTimeDeliveryDate,
          urgentDelivery: isCheckedUrgentDelivery,
          deliveryRequest: isCheckedHomeDelivery,
          regenerateInvoice: regenerateInvoice,
          regenerateQRCode: regenerateQRCode,
          remarks: otherRemarkValue,
          deliveredOn: currentDateTimeDeliveredOnDate,
          gstApply:
            userCheckGST === true
              ? isCheckedGST === true
                ? "yes"
                : "no"
              : "none",
          customerName: [
            storeCustomerData?.brandCustomer?.firstName,
            storeCustomerData?.brandCustomer?.lastName,
          ]
            .filter((name) => name && name !== "null" && name !== "undefined")
            .join(" "),
          customerMobile: storeCustomerData?.brandCustomer?.mobile,
          customerAddress: storeCustomerData?.address?.address,
        };

        // setIsSubmitButtonPressed(false);
        // setOrderInfoEditVisible(false);

        // Call the service function for creating pickup request
        orderInfoEditAdmin(
          storeCustomerId,
          storeId,
          customerOrdersData?.id,
          data
        )
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                }

                setIsSubmitButtonPressed(false);
                setRegenerateInvoice(true);
                setRegenerateQRCode(true);
                sendResponse({
                  message,
                  status,
                  modalFun: false,
                });
                setErrorMessage("");
                setUserCheckGST(false);
                //  setCheckedGST(false);
                setOrderInfoEditVisible(false);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    } else {
      setIsSubmitButtonPressed(false);
      setRegenerateInvoice(true);
      setRegenerateQRCode(true);
    }
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={orderInfoEditVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!orderInfoEditVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-1 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-3xl text-primary-50 font-semibold">
                Order Info
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 p-1"
              ></Button>
            </div>

            
              <div
                className="h-25rem scroll-bar"
                style={{
                  overflowY: "scroll",
                }}
              >
                <React.Fragment>
                  <div className="flex justify-content-between align-items-center mx-4 my-2">
                    <p className="text-xl font-medium capitalize p-0">
                      Booking Date
                    </p>
                    <Calendar
                      id="buttondisplay"
                      value={bookingDate}
                      minDate={new Date(profileCreatedDate)}
                      maxDate={deliveryDate}
                      onChange={(e) => handleBookingDateChange(e.value)}
                      showIcon
                      className="w-auto p-0"
                      dateFormat="dd/mm/yy"
                    />
                  </div>
                  <div className="flex justify-content-between align-items-center mx-4 my-2">
                    <p className="text-xl font-medium capitalize">
                      Delivery Date
                    </p>
                    <Calendar
                      id="buttondisplay"
                      value={deliveryDate}
                      minDate={bookingDate}
                      maxDate={maximumValidDate}
                      onChange={(e) => handleDeliveryDateChange(e.value)}
                      showIcon
                      className="w-auto p-0"
                      dateFormat="dd/mm/yy"
                    />
                  </div>

                {["DONE", "DELIVERED"].includes(customerOrdersData?.status) && (
                  <div className="flex justify-content-between align-items-center mx-4">
                    <p className="text-xl font-medium capitalize p-0">
                      Delivered On Date
                    </p>
                    <Calendar
                      id="buttondisplay"
                      value={deliveredOnDate}
                      minDate={bookingDate}
                      maxDate={maximumValidDeliveredOnDate}
                      onChange={(e) => handleDeliveredOnDateChange(e.value)}
                      showIcon
                      className="w-auto"
                      dateFormat="dd/mm/yy"
                    />
                  </div>
                )}

                  <div className="flex-1 flex mx-4 gap-4 my-2">
                    <div
                      className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <p
                        className=" text-md font-normal capitalize"
                        style={{ color: "#6b7280" }}
                      >
                        Home Delivery
                      </p>
                      <Checkbox
                        checked={isCheckedHomeDelivery}
                        onChange={() =>
                          setCheckedHomeDelivery(!isCheckedHomeDelivery)
                        }
                      ></Checkbox>
                    </div>

                    <div
                      className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <p
                        className=" text-md font-normal capitalize"
                        style={{ color: "#6b7280" }}
                      >
                        Urgent Delivery
                      </p>
                      <Checkbox
                        checked={isCheckedUrgentDelivery}
                        onChange={() =>
                          setIsCheckedUrgentDelivery(!isCheckedUrgentDelivery)
                        }
                      ></Checkbox>
                    </div>
                  </div>

                  <div className="flex-1 flex mx-4 gap-4 my-2">
                    <div
                      className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <p
                        className=" text-md font-normal capitalize"
                        style={{ color: "#6b7280" }}
                      >
                        Regenerate Invoice
                      </p>
                      <Checkbox
                        checked={regenerateInvoice}
                        onChange={() =>
                          setRegenerateInvoice(!regenerateInvoice)
                        }
                      ></Checkbox>
                    </div>

                    <div
                      className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <p
                        className=" text-md font-normal capitalize"
                        style={{ color: "#6b7280" }}
                      >
                        Regenerate Tag
                      </p>
                      <Checkbox
                        checked={regenerateQRCode}
                        onChange={() => setRegenerateQRCode(!regenerateQRCode)}
                      ></Checkbox>
                    </div>
                  </div>

                  {storeGstNumber !== null && storeGstNumber !== "" && (
                    <div className="flex-1 flex mx-4 gap-4 my-2">
                      <div className="flex-1 mb-1 mt-3">
                        <div
                          className="border-round-lg shadow-2 flex px-3 py-2 justify-content-between"
                          style={{
                            backgroundColor: "#fff",
                          }}
                        >
                          <p
                            className=" text-md font-normal capitalize"
                            style={{ color: "#6b7280" }}
                          >
                              {storeLocalData?.taxType} {storeLocalData?.currencySymbol} {gstAmountValue}
                          </p>
                          <div>
                            <Checkbox
                              onChange={() => handleGSTCheck(isCheckedGST)}
                              checked={isCheckedGST}
                            ></Checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex-1 mx-4 my-2">
                    <div
                      className="border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <InputText
                        placeholder="Other Remark"
                        value={otherRemarkValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleOtherRemarkChange(e.target.value)
                        }
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                    </div>
                  </div>
                  <div
                    className="shadow-2 mx-4 border-2 border-round-lg cursor-pointer my-2"
                    style={{ borderColor: "#276bcf" }}
                  >
                    <div
                      className="px-3 pb-1 flex flex-row justify-content-between align-items-center"
                      style={{
                        backgroundColor: "#276bcf",
                      }}
                      onClick={handleShowHide}
                    >
                      <p className="text-white text-xl font-bold capitalize">
                        Get Customer Info
                      </p>
                      <i
                        className={
                          !show ? "pi pi-angle-down" : "pi pi-angle-up"
                        }
                        style={{
                          fontSize: "25px",
                          cursor: "pointer",
                          color: "#fff",
                        }}
                      ></i>
                    </div>
                  </div>
                  {show && (
                    <div className="flex-1 flex mx-4 gap-4 my-2">
                      <div
                        className="border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <InputText
                          placeholder="Customer Name"
                          value={[
                            storeCustomerData?.brandCustomer?.firstName,
                            storeCustomerData?.brandCustomer?.lastName,
                          ]
                            .filter(
                              (name) =>
                                name && name !== "null" && name !== "undefined"
                            )
                            .join(" ")}
                          className="w-full border-none px-3 text-md "
                          disabled={true}
                        ></InputText>
                      </div>
                      <div
                        className="border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <InputText
                          placeholder="Mobile No."
                          value={storeCustomerData?.brandCustomer?.mobile}
                          className="w-full border-none px-3 text-md "
                          disabled={true}
                        ></InputText>
                      </div>
                      <div
                        className="border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <InputText
                          placeholder="Customer Address"
                          value={storeCustomerData?.address?.address}
                          className="w-full border-none px-3 text-md "
                          disabled={true}
                        ></InputText>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              </div>

            <Button
              disabled={isSubmitButtonPressed}
              onClick={onUpdateButtonPress}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Submit Request
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default OrderInfoEditAdmin;
